module.exports = __webpack_public_path__ + "static/img/mob-1.dec41ea2.jpeg";